module.exports = __webpack_public_path__ + "static/media/arrow-blue.b23bb22b.svg";